import { Flex, Radio, RadioChangeEvent } from 'antd'
import { IAnswerWithValue, IScale } from '@/models'

interface ITitleRateProps {
  question: IScale | undefined
  value: number | undefined
  onChange: (e: number) => void
  prefixcls?: string
}

export const RateTitle = ({ question, value, onChange, prefixcls }: ITitleRateProps) => (
  <Flex>
    <Radio.Group
      options={question?.answers
        ?.filter((v: IAnswerWithValue) => v?.value !== 99)
        ?.map((item: IAnswerWithValue) => ({ value: item?.value, label: item?.title }))}
      onChange={(e: RadioChangeEvent) => onChange(e.target.value)}
      value={value}
      optionType='button'
      buttonStyle='outline'
      style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
      prefixCls={prefixcls}
    />
  </Flex>
)
